import actionCreatorFactory from "typescript-fsa";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";
import api from "../api";
import { Entity } from "../documentUpload/types";
import { State } from "../state";
import { getEntityListPage } from "./selector";
import { ENTITY_COLUMNS, Pagination, Search } from "./types";

const create = actionCreatorFactory("Entities");
const createAsync = asyncFactory<State>(create);

export interface GetEntitiesParams {
  getEntityListPage: any;
  filter?: string;
  sortColumn?: ENTITY_COLUMNS;
  sortAscending?: boolean;
}

export const updatePage = create<Pagination>("UPDATE_PAGE");
export const updateSearch = create<Search>("UPDATE_SEARCH");

export const getEntities = createAsync<GetEntitiesParams, Entity[]>(
  "GET_ENTITIES",
  async (params, dispatch, getState) => {
    return await api.entities.get(
      getEntityListPage(getState()),
      params.filter,
      params.sortColumn,
      params.sortAscending
    );
  }
);

const getEntitiesAction = thunkToAction(getEntities.action);
export type GetEntitiesActionType = typeof getEntitiesAction;



// WEBPACK FOOTER //
// ./src/entityList/actions.ts